import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';

export const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-6 text-center">
      <div className="p-4 bg-red-100 rounded-full">
        <AlertCircle className="h-16 w-16 text-red-500" />
      </div>

      <div className="space-y-2">
        <h1 className="text-6xl font-bold text-gray-900">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700">Page Not Found</h2>
        <p className="text-muted-foreground max-w-md">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
      </div>

      <Link to="/">
        <Button variant="primary" size="lg" leftIcon={<Home className="h-4 w-4" />}>
          Back to Home
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
